import { gql } from '@apollo/client';

export const DEPOSIT_ORDER = gql`
  mutation createPayPalOrder($input: PaypalOrderInput!) {
    createPayPalOrder(input: $input) {
      id
    }
  }
`;
